export interface NotificationUiState {
  /** Whether to show the unread notification badge in the toolbar bell */
  showUnreadIndicator: boolean;
}

export const initialNotificationUiState: NotificationUiState = {
  showUnreadIndicator: false,
};
